import { render } from "./countries-per-level.vue?vue&type=template&id=5a3ade0f&ts=true"
import script from "./countries-per-level.ts?vue&type=script&lang=ts&external"
export * from "./countries-per-level.ts?vue&type=script&lang=ts&external"

import "./countries-per-level.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__